export enum MethodOfCitation {
	InPerson = 1,
	LiveVideo = 2,
	DayOneReconciliation = 3,
}
